export default "__VITE_ASSET__BG273Ov6__"